/** Putovanja koja imaju stranicu predugovornih informacija. */
const KEYS = [
  "alicante",
  "alicante-maj",
  "alicante-ozujak",
  "madrid-segovia",
  "valladolid-1tjedan",
  "valladolid-2tjedan",
  "valladolid-1tjedan-lipanj",
  "valladolid-2tjedan-lipanj",
  "od-madrida-do-vinograda",
  "valencia",
];

export function tourHasPreContract(tourKey) {
  return KEYS.includes(tourKey);
}
